export default "__VITE_ASSET__V6ZFE232__"